<template>
    <div>
        <b-modal
            :visible="value"
            :id="modal_id"
            size="lg"
            @cancel="cancel"
            @close="cancel"
            @hidden="hidden"
        >
            <template #modal-title>
                Upload Teacher Edition
            </template>

            <b-form-file
                v-model="new_teacher_edition_pdf_file"
                accept="application/pdf"
                class="mb-3"
            />

            <div v-if="uploading_file" class="mb-3">
                <b-spinner label="File is Uploading...." />
            </div>

            <template #modal-footer>
                <b-button
                    variant="light"
                    @click="cancel"
                >
                    Cancel
                </b-button>
                <b-btn
                    class='mt-3 mb-3'
                    variant="primary"
                    :disabled="uploading_file"
                    @click="uploadPdfAsUnitTeacherEdition">
                    Upload PDF
                </b-btn>
            </template>
        </b-modal>
    </div>
</template>

<script>
import moment from 'moment'
import {mapState} from 'vuex'

export default {
    data: () => ({
        new_teacher_edition_pdf_file: null,
        uploading_file: false,
    }),
    props: [
        'value',
        'publication',
        'unit_group',
        'unit',
    ],
    components: {},
    computed: {
        modal_id() {
            let modal_id = 'upload-teacher-edition-modal'
            return modal_id
        },
        ...mapState({
            user: state => state.user.user,
        }),
        can_create_flipbook() {
            return this.user && this.user.permissions && _.includes(this.user.permissions, 'create_flipbook')
        },
        can_delete_flipbook() {
            return this.user && this.user.permissions && _.includes(this.user.permissions, 'delete_flipbook')
        },
    },
    methods: {
        cancel(event) {
            event.preventDefault()
            this.hide()
        },
        hide() {
            this.$emit('hide')
        },
        hidden() {
            this.$emit('hide')
        },
        async uploadPdfAsUnitTeacherEdition() {
            const form_data = new FormData()
            form_data.append('file', this.new_teacher_edition_pdf_file)

            if (!this.new_teacher_edition_pdf_file) {
                this.$swal('There is information missing. Please confirm that you have selected a pdf to upload.')
                return
            }
            try {
                const endpoint = `/api/unit/upload_teacher_edition/${this.publication.id}/${this.unit_group.id}/${this.unit.id}`
                this.uploading_file = true
                await this.axios.post(endpoint, form_data)
                this.$emit('update_te')
                await this.handleFlipBookUpdate()
            } catch (e) {
                const message = `Failed to upload TE: ${e.message}`
                await this.$store.dispatch('pushError', {
                    data: {message},
                    time: moment().toISOString(),
                })
            } finally {
                this.uploading_file = false
                this.hide()
            }
        },
        async handleFlipBookUpdate() {
            const flipbooks = await this.axios.get(`/api/units/flipbooks/${this.unit.id}`)
            if (!flipbooks || !flipbooks.data) {
                return
            }
            const teFlipBook = flipbooks.data.find((book) => book.book_type === 'teacher')
            if (!teFlipBook) {
                return
            }
            if (!this.can_create_flipbook || !this.can_delete_flipbook) {
                await this.$swal({
                    html: 'This Teacher Edition has an existing Flip Book that will need to be updated.',
                })
                return
            }

            const result = await this.$swal({
                html: 'This Teacher Edition has an existing Flip Book. Update it?',
                showCancelButton: true,
                confirmButtonText: 'Update',
                cancelButtonText: 'Cancel',
                confirmButtonColor: '#3498db',
                reverseButtons: true,
            })
            if (result.value) {
                const payload = {
                    'unit_id': this.unit.id,
                    'type': 'teacher',
                    'url': this.unit.lesson_plan_url,
                    'title': `Teacher Edition${this.unit.order_number ? ' ' + this.unit.order_number : ''}`,
                }
                await this.axios.delete(`/api/flipbook/${teFlipBook.id}`)
                await this.axios.post('/api/flipbook', payload)
            }

        },
    }
}
</script>
